import { CalendarDays, Compass, House, UsersRound } from "lucide-react";
import type { Tab } from "@/lib/address";

/**
 * The tabs the phone's bar and the desktop's top bar share, in order: Início,
 * Caminhadas, Comunidade and Os meus eventos (montanhas-web#16). Os meus eventos
 * needs an account and opens the sign-in sheet signed out, so what an account
 * gets you stays in view; Comunidade needs none, and shows everyone's totals
 * signed out.
 */
export type TabItem = { id: Tab; label: string; icon: typeof Compass; account?: boolean };

export const TABS: TabItem[] = [
  { id: "home", label: "Início", icon: House },
  { id: "explore", label: "Caminhadas", icon: Compass },
  { id: "community", label: "Comunidade", icon: UsersRound },
  { id: "events", label: "Os meus eventos", icon: CalendarDays, account: true },
];
